/**
 * Trigger: tr_expenses_soft_delete_external
 * Purpose: When an expense is soft-deleted, detach its related external marker links
 * Table: expenses
 * Event: UPDATE OF is_deleted
 */
export const TR_EXPENSES_SOFT_DELETE_EXTERNAL = `
CREATE TRIGGER tr_expenses_soft_delete_external
UPDATE OF is_deleted ON expenses
WHEN new.is_deleted <> 0 AND old.is_deleted = 0
BEGIN
  UPDATE external_transactions
  SET expense_id = NULL
  WHERE expense_id = old._id AND is_deleted = 0;
END;
`;
